<template>
  <div id="studentRequirementForm" class="form">
    <v-form v-if="loaded" ref="form" v-model="valid" lazy-validation>
      <v-select
        v-model="studentRequirement.student"
        :items="studentRequirement.relations.student"
        label="Student"
        :multiple="false"
        item-text="firstName"
        item-value="id"
        :chips="false"
        deletable-chips
      ></v-select
      ><v-select
        v-model="studentRequirement.requirement"
        :items="studentRequirement.relations.requirement"
        label="Requirement"
        :multiple="false"
        item-text="name"
        item-value="id"
        :chips="false"
        deletable-chips
      ></v-select>
      <div class="mt-4 d-flex justify-space-between">
        <v-btn @click="goBack">
          Back
        </v-btn>
        <v-btn @click="handleSubmit" color="primary">
          {{ id ? "Update" : "Save" }}
        </v-btn>
        <span></span>
      </div>
    </v-form>
  </div>
</template>

<script>
import { getStudentRequirement } from "@/services/studentRequirement";

import { getAllStudents } from "@/services/student";

import { getAllRequirements } from "@/services/requirement";

import { mapActions } from "vuex";

export default {
  props: ["id"],
  data() {
    return {
      loaded: false,
      valid: false,
      studentRequirement: {
        relations: {
          student: [],
          requirement: []
        },
        student: {},
        requirement: {}
      }
    };
  },
  created() {
    this.setInstance();
  },
  methods: {
    ...mapActions("studentRequirement", [
      "createStudentRequirement",
      "updateStudentRequirement"
    ]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage"
    ]),

    async handleSubmit() {
      if (this.id) {
        let studentRequirement = this.studentRequirement;
        delete studentRequirement.relations;

        this.updateStudentRequirement(studentRequirement)
          .then(response => {
            console.log(response);
            this.addSuccessMessage(
              "StudentRequirement was updated successfully"
            );
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage(
              "Error updating StudentRequirement, please try again later"
            );
          });
      } else {
        let studentRequirement = this.studentRequirement;
        delete studentRequirement.relations;

        this.createStudentRequirement(studentRequirement)
          .then(response => {
            console.log(response);
            this.addSuccessMessage(
              "StudentRequirement was created successfully"
            );
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage(
              "Error creating StudentRequirement, please try again later"
            );
          });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    setInstance() {
      if (this.id) {
        this.studentRequirement.id = this.id;
        getStudentRequirement(this.id).then(response => {
          let instance = response.data;
          for (let property in instance) {
            if (
              Object.prototype.hasOwnProperty.call(instance, property) &&
              Object.prototype.hasOwnProperty.call(
                this.studentRequirement,
                property
              )
            ) {
              this.studentRequirement[property] = instance[property];
            }
          }
          this.loaded = true;
        });
      } else {
        this.loaded = true;
      }
      this.setDependencies();
    },
    setDependencies() {
      const params_student = {
        page: 0,
        size: 100
      };
      getAllStudents(params_student).then(response => {
        this.studentRequirement.relations.student = response.data.content;
      });

      const params_requirement = {
        page: 0,
        size: 100
      };
      getAllRequirements(params_requirement).then(response => {
        this.studentRequirement.relations.requirement = response.data.content;
      });
    }
  },
  components: {}
};
</script>
